"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "ktx.transplantationScreening.cardiology.coronarography.result.ABNORMAL",
        defaultMessage: "Van eltérés"
    },
    [Result.NORMAL]: {
        id: "ktx.transplantationScreening.cardiology.coronarography.result.NORMAL",
        defaultMessage: "Nincs eltérés"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
]);
const description = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result, description })
    .interpretation({ vocab: "ktx", code: "cardiology_coronarography" })
    .tag({ vocab: "ktx", code: "cardiology" });
